// Module
var code = "<h2 id=\"confirm-your-action\">Confirm your action!</h2> <p>Before proceeding, please note that your API-key will be permanently deleted and this action is not reversible. You may want to deactivate it instead.</p> ";
// Exports
module.exports = code;